(() => {
  'use strict';
  const config = window.MG_CONFIG || {};
  const routes = config.routes || { root: '/', all: '/collections/all', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', contact: '/' };
  const bikes = config.bikes || {};
  const bikePhotos = config.bikePhotos || [];
  const categories = config.categories || [];
  const brandNames = Object.keys(bikes);
  const shopName = config.shopName || '';
  const products = (window.MG_PRODUCTS || []).map(p => ({ ...p, brand: brandNames.includes(p.vendor) ? p.vendor : 'Universal', models: Array.isArray(p.models) ? p.models : [] }));
  const body = document.body;
  const template = body.dataset.template || '';
  const onBikesPage = template === 'collection' && body.dataset.templateSuffix === 'bikes';
  const onShopPage = template === 'collection' && !onBikesPage;
  const onProductPage = template === 'product';
  const onCartPage = template === 'cart';
  const siteHeader = document.getElementById('site-header');
  const announcement = document.querySelector('.announcement');

  const syncHeaderHeight = () => {
    if (!siteHeader) return;
    document.documentElement.style.setProperty('--sticky-header-height', `${siteHeader.getBoundingClientRect().height}px`);
    document.documentElement.style.setProperty('--announcement-height', `${announcement?.getBoundingClientRect().height || 0}px`);
  };
  syncHeaderHeight();
  if ('ResizeObserver' in window && siteHeader) {
    const headerObserver = new ResizeObserver(syncHeaderHeight);
    headerObserver.observe(siteHeader);
    if (announcement) headerObserver.observe(announcement);
  } else {
    window.addEventListener('resize', syncHeaderHeight);
  }
  const syncDialogViewport = () => {
    const viewport = window.visualViewport;
    if (viewport && viewport.scale !== 1) return;
    const height = viewport?.height || window.innerHeight;
    const root = document.documentElement;
    root.style.setProperty('--dialog-viewport-height', `${height}px`);
    root.style.setProperty('--dialog-viewport-top', `${viewport?.offsetTop || 0}px`);
    root.toggleAttribute('data-compact-viewport', height < 480);
  };
  syncDialogViewport();
  window.addEventListener('resize', syncDialogViewport, { passive: true });
  window.visualViewport?.addEventListener('resize', syncDialogViewport, { passive: true });
  window.visualViewport?.addEventListener('scroll', syncDialogViewport, { passive: true });

  const money = value => new Intl.NumberFormat('en-IN', { style: 'currency', currency: config.currency || 'INR', maximumFractionDigits: 0 }).format(value);
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const responsiveCopy = (desktop, mobile) => `<span class="desktop-copy">${esc(desktop)}</span><span class="mobile-copy">${esc(mobile)}</span>`;
  const icon = name => `<svg class="icon" aria-hidden="true"><use href="#i-${name}"></use></svg>`;
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const segMemory = new Map();
  function syncSegments(root = document) {
    root.querySelectorAll('[data-seg]').forEach(group => {
      group.classList.add('has-seg');
      let indicator = group.querySelector(':scope > .seg-indicator');
      if (!indicator) { indicator = document.createElement('span'); indicator.className = 'seg-indicator'; indicator.setAttribute('aria-hidden', 'true'); group.prepend(indicator); }
      const active = group.querySelector(':scope > [aria-pressed="true"], :scope > [aria-current="true"]');
      if (!active) { indicator.style.opacity = '0'; segMemory.delete(group.dataset.seg); return; }
      const target = { x: active.offsetLeft, y: active.offsetTop, w: active.offsetWidth, h: active.offsetHeight };
      const place = r => { indicator.style.width = `${r.w}px`; indicator.style.height = `${r.h}px`; indicator.style.transform = `translate(${r.x}px, ${r.y}px)`; };
      const previous = segMemory.get(group.dataset.seg);
      indicator.style.opacity = '1';
      if (previous && !reduceMotion()) { indicator.style.transition = 'none'; place(previous); void indicator.offsetWidth; indicator.style.transition = ''; }
      place(target);
      segMemory.set(group.dataset.seg, target);
    });
  }
  function animateIn(container) {
    if (!container || reduceMotion()) return;
    [...container.children].slice(0, 12).forEach((card, i) => { card.style.setProperty('--i', i); card.classList.remove('anim-in'); void card.offsetWidth; card.classList.add('anim-in'); });
  }
  const motionOn = () => document.documentElement.classList.contains('motion');
  const revealSelector = '.section-head, .product-card, .category-tile, .part-type, .ride-guide-panel, .help-band .container, .benefit, .explore-tile, .model-choice-explore, .bike-model-card, .pdp-accordions, .universal-options .result-heading, .cart-page-summary, .footer-grid > *, .footer-bottom, .mg-page .rte';
  let revealObserver = null;
  function observeReveal(root = document) {
    if (!motionOn() || !('IntersectionObserver' in window)) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(entries => {
        let order = 0;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          revealObserver.unobserve(el);
          el.style.transitionDelay = `${Math.min(order++, 6) * 70}ms`;
          el.classList.add('is-revealed');
          setTimeout(() => { el.classList.remove('reveal', 'is-revealed'); el.style.transitionDelay = ''; }, 1200);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
    }
    root.querySelectorAll(revealSelector).forEach(el => {
      if (el.dataset.reveal) return;
      el.dataset.reveal = '1';
      const r = el.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) return;
      el.classList.add('reveal');
      revealObserver.observe(el);
    });
  }
  const navProgress = document.createElement('div');
  navProgress.className = 'nav-progress';
  navProgress.setAttribute('aria-hidden', 'true');
  document.body.appendChild(navProgress);
  function startNavProgress() { navProgress.classList.remove('is-loading'); void navProgress.offsetWidth; navProgress.classList.add('is-loading'); }
  window.addEventListener('pageshow', () => navProgress.classList.remove('is-loading'));
  const findProduct = id => products.find(p => p.id === id);
  const blurSrc = src => /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1120') : src;
  const photoFills = image => Boolean(image && image.width >= 500 && image.height && Math.abs(image.width / image.height - 1) <= 0.05);
  const percentOff = (price, compareAt) => compareAt > price ? Math.round((compareAt - price) / compareAt * 100) : 0;
  const offBadge = (price, compareAt, className = 'price-off') => { const off = percentOff(price, compareAt); return off >= 1 ? `<span class="${className}">${off}% OFF</span>` : ''; };
  const imageFor = p => p.image;
  const imageTag = (image, alt, extra = '') => image ? `<img class="od-media" src="${esc(image.src)}" width="${image.width}" height="${image.height}" alt="${esc(alt)}" loading="${extra.includes('fetchpriority="high"') ? 'eager' : 'lazy'}" decoding="async" ${extra}>` : '';
  const storageGet = (key, fallback) => { try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; } };
  const storageSet = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* The current session keeps its state when storage is unavailable. */ } };
  const readJSON = id => { try { return JSON.parse(document.getElementById(id)?.textContent || 'null'); } catch { return null; } };
  const rootURL = hash => `${routes.root}${routes.root.endsWith('/') ? '' : '/'}${hash ? `#${hash}` : ''}`;

  const bikePhoto = (brand, model) => bikePhotos.find(photo => photo.brand === brand && photo.model === model);
  const bikeSelectionURL = brand => Object.hasOwn(bikes, brand) ? `${routes.all}?view=bikes&brand=${encodeURIComponent(brand)}` : rootURL('bike-finder');
  const selectionBrand = (search = location.search) => { const brand = new URLSearchParams(search).get('brand') || ''; return Object.hasOwn(bikes, brand) ? brand : ''; };
  const selectionModel = (search = location.search) => { const model = new URLSearchParams(search).get('model') || ''; return bikes[selectionBrand(search)]?.includes(model) ? model : ''; };

  const savedBike = storageGet('motogarage-bike-v1', {});
  let bike = savedBike && typeof savedBike === 'object' && Object.hasOwn(bikes, savedBike.brand) ? { brand: savedBike.brand, model: bikes[savedBike.brand].includes(savedBike.model) ? savedBike.model : '' } : { brand: '', model: '' };
  const shopPath = document.querySelector('[data-shop-root]')?.dataset.collectionUrl || routes.all;
  const storedShop = storageGet('motogarage-last-shop-v1', '');
  const validShop = value => typeof value === 'string' && value.startsWith('/collections/') && !value.includes('view=');
  let lastShop = validShop(storedShop) ? storedShop : routes.all;
  let cart = readJSON('mg-cart-state') || { items: [], item_count: 0, total_price: 0 };
  let cartChanged = false;
  let lightboxState = null;
  let bikeReturnCart = false;
  let purchaseResizeObserver = null;
  let pendingFocus = null;
  let preserveScroll = null;
  let lastRemoved = null;
  let toastTimer = null;
  let searchContext = null;
  let firstRender = true;
  const showcasePageSize = 8;
  let showcaseBrand = '';
  let showcaseLimit = showcasePageSize;

  const queryOf = url => { try { return new URL(url, location.origin).search; } catch { return ''; } };
  const getFilters = (search = location.search) => {
    const params = new URLSearchParams(search);
    let brand = params.has('brand') ? params.get('brand') : bike.brand;
    if (!Object.hasOwn(bikes, brand)) brand = '';
    let model = params.has('model') ? params.get('model') : (brand === bike.brand ? bike.model : '');
    if (!brand && model) brand = Object.keys(bikes).find(b => bikes[b].includes(model)) || '';
    if (!bikes[brand]?.includes(model)) model = '';
    return { brand, model, category: categories.includes(params.get('category')) ? params.get('category') : '', q: params.get('q') || '', sort: ['featured', 'price-low', 'price-high', 'name'].includes(params.get('sort')) ? params.get('sort') : 'featured' };
  };
  const shopURL = (updates = {}, base = { brand: bike.brand, model: bike.model }, path = onShopPage ? shopPath : routes.all) => {
    const f = { ...base, ...updates };
    const params = new URLSearchParams();
    for (const k of ['brand', 'model', 'category', 'q', 'sort']) if (f[k] || ['brand', 'model'].includes(k)) params.set(k, f[k] || '');
    return `${path}?${params.toString()}`;
  };
  const setBike = (brand, model) => {
    bike = { brand, model };
    storageSet('motogarage-bike-v1', bike);
  };
  const rememberShop = url => { if (validShop(url)) { lastShop = url; storageSet('motogarage-last-shop-v1', lastShop); } };
  const currentPath = () => `${location.pathname}${location.search}`;

  function browseContext() {
    if (onShopPage) return getFilters();
    if (onBikesPage) return { brand: selectionBrand(), model: selectionModel(), category: '', q: '', sort: 'featured' };
    const base = getFilters(queryOf(lastShop));
    if (onProductPage && productPage) {
      const product = productPage;
      if (product.brand !== 'Universal') {
        const sameBrand = base.brand === product.brand;
        return { ...base, brand: product.brand, model: sameBrand ? base.model : (bike.brand === product.brand ? bike.model : ''), category: sameBrand ? base.category : '', q: '' };
      }
      return base;
    }
    if (onCartPage) return base;
    return { brand: bike.brand, model: bike.model, category: '', q: '', sort: 'featured' };
  }
  function updateHeader() {
    const count = cart.item_count || 0;
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      const before = Number(el.textContent) || 0;
      el.textContent = count; el.hidden = !count;
      if (count > before && !firstRender && !reduceMotion()) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    });
    const context = browseContext();
    document.querySelectorAll('[data-brand-link]').forEach(el => {
      if ((onShopPage || onBikesPage || onProductPage) && el.dataset.brandLink === context.brand) el.setAttribute('aria-current', 'page');
      else el.removeAttribute('aria-current');
    });
    document.querySelectorAll('[data-cart-trigger]').forEach(el => el.setAttribute('aria-label', `Open cart, ${count} ${count === 1 ? 'item' : 'items'}`));
  }
  function closeDialogs() { document.querySelectorAll('dialog[open]').forEach(d => d.close()); }
  function openDialog(id) {
    rememberPurchase();
    if (id === 'bike-dialog') bikeReturnCart = !!document.getElementById('cart-dialog')?.open;
    const d = document.getElementById(id);
    if (!d) return;
    closeDialogs();
    if (id === 'cart-dialog') renderCart();
    if (id === 'bike-dialog') d.querySelector('.dialog-body').innerHTML = `<p class="muted">Choose your model to find the parts listed for it.</p>${finderForm('dialog')}`;
    d.showModal();
    body.classList.add('dialog-open');
    syncPurchaseBar();
    if (id === 'search-dialog') {
      const context = browseContext();
      document.getElementById('search-input').value = context.q;
      setSearchScope(context);
      d.querySelector('input').focus();
    }
  }
  function closeDialog(d) {
    if (!d?.open) return;
    if (reduceMotion() || d.classList.contains('is-closing')) { d.classList.remove('is-closing'); d.close(); return; }
    d.classList.add('is-closing');
    setTimeout(() => { d.classList.remove('is-closing'); d.close(); }, 170);
  }
  document.querySelectorAll('dialog').forEach(d => {
    d.addEventListener('cancel', e => { e.preventDefault(); closeDialog(d); });
    d.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) body.classList.remove('dialog-open');
      syncPurchaseBar();
    });
    d.addEventListener('click', e => {
      if (e.target !== d) return;
      const r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(d);
    });
  });
  function notify(message, showCart = false, undo = false) {
    const el = document.getElementById('toast');
    if (!el) return;
    const host = document.querySelector('dialog[open]') || document.body;
    if (el.parentElement !== host) host.appendChild(el);
    clearTimeout(toastTimer);
    el.innerHTML = `${icon('check')}<span>${esc(message)}</span>${showCart ? '<button type="button" data-action="cart">View cart</button>' : ''}${undo ? '<button type="button" data-action="cart-undo">Undo</button>' : ''}`;
    el.hidden = false;
    toastTimer = setTimeout(() => { el.hidden = true; }, 5000);
  }
  function navigate(url, options = {}) {
    const target = new URL(url, location.href);
    closeDialogs();
    const sameDocument = target.pathname === location.pathname && target.origin === location.origin;
    const isBikesURL = target.searchParams.get('view') === 'bikes';
    if (sameDocument && ((onShopPage && !isBikesURL) || (onBikesPage && isBikesURL))) {
      pendingFocus = options.focusId || null;
      preserveScroll = options.preserveScroll ? window.scrollY : null;
      if (target.href !== location.href) history.pushState({}, '', target);
      renderPage();
      return;
    }
    startNavProgress();
    location.href = target.href;
  }
  function finderForm(prefix) {
    const context = bike.brand ? bike : browseContext();
    return `<form class="od-stack bike-form" data-form="bike" novalidate>
      <div class="field od-field"><label for="${prefix}-brand">Bike brand</label><select id="${prefix}-brand" name="brand" required aria-describedby="${prefix}-brand-error"><option value="">Choose your brand</option>${Object.keys(bikes).map(b => `<option ${context.brand === b ? 'selected' : ''}>${esc(b)}</option>`).join('')}</select><span class="field-error" id="${prefix}-brand-error" hidden></span></div>
      <div class="field od-field"><label for="${prefix}-model">Bike model</label><select id="${prefix}-model" name="model" ${context.brand ? '' : 'disabled'}><option value="">Choose a model</option>${(bikes[context.brand] || []).map(m => `<option ${context.model === m ? 'selected' : ''}>${esc(m)}</option>`).join('')}</select></div>
      <button class="btn btn-dark" type="submit">${onProductPage || onCartPage ? 'Save my bike' : 'Find my parts'}</button>
    </form>`;
  }

  function fitLabel(p) { return p.models.length ? p.models.join(' / ') : 'Confirm bike fitment'; }
  function productCard(p, presentation) {
    const im = imageFor(p);
    const linked = presentation === 'linked';
    const quick = presentation === 'quick' && p.available && p.variantCount === 1 && p.variantId;
    const outerTag = linked ? 'a' : 'article';
    const innerTag = linked ? 'span' : 'a';
    const href = p.url;
    const titleId = `showcase-name-${p.id}`;
    const fitId = `showcase-fit-${p.id}`;
    return `<${outerTag} class="product-card od-tile${linked ? ' product-card-link' : ''}"${linked ? ` href="${esc(href)}" aria-labelledby="${esc(titleId)}" aria-describedby="${esc(fitId)}"` : ''}>
      <div class="product-photo${photoFills(im) ? ' product-photo-fill' : im ? ' has-blur' : ''}"${im && !photoFills(im) ? ` style="--photo-bg:url('${esc(blurSrc(im.src))}')"` : ''}>${offBadge(p.price, p.compareAt, 'photo-off')}${linked ? `<div class="product-image-frame">${imageTag(im, '')}</div>` : `<a href="${esc(href)}" tabindex="-1" aria-hidden="true">${imageTag(im, p.shortName)}</a>`}</div>
      <div class="product-info"><span class="product-category">${esc(p.category)}</span><${innerTag} class="product-title od-clamp-2" ${linked ? `id="${esc(titleId)}"` : `href="${esc(href)}"`}>${esc(p.shortName)}</${innerTag}><span class="product-fit od-clamp-2"${linked ? ` id="${esc(fitId)}"` : ''}>${esc(fitLabel(p))}</span>${p.brand === 'Universal' ? `<span class="product-badge">${responsiveCopy('Universal · Check fitment', 'Check fitment')}</span>` : ''}
      <div class="product-price-row"><div class="od-field"><span class="od-nowrap"><span class="price">${money(p.price)}</span>${p.compareAt > p.price ? `<s class="compare-price">${money(p.compareAt)}</s>` : ''}</span>${!p.available ? '<span class="availability-label">Unavailable</span>' : ''}</div>${quick ? `<button type="button" class="card-add" data-action="quick-add" data-product="${esc(p.id)}" aria-label="Add ${esc(p.shortName)} to cart">${icon('bag-plus')}<span class="card-add-label">Add</span></button>` : ''}<${innerTag} class="product-open"${linked ? ' aria-hidden="true"' : ` href="${esc(href)}" aria-label="View ${esc(p.shortName)}"`}><span class="mobile-copy">View part</span>${icon('arrow')}</${innerTag}></div></div>
    </${outerTag}>`;
  }

  /* Home page */
  const showcaseRoot = document.querySelector('[data-showcase-body]');
  const showcaseOrder = (() => {
    if (!showcaseRoot) return [];
    try { return JSON.parse(showcaseRoot.dataset.handles || '[]').map(findProduct).filter(Boolean); } catch { return []; }
  })();
  function showcaseProducts(brand = showcaseBrand) {
    const byBrand = name => showcaseOrder.filter(p => p.brand === name);
    if (brand) return byBrand(brand);
    const lists = brandNames.map(byBrand);
    const combined = [];
    for (let i = 0; i < Math.max(0, ...lists.map(list => list.length)); i++) lists.forEach(list => { if (list[i]) combined.push(list[i]); });
    return combined;
  }
  function homeShowcase() {
    const pool = showcaseProducts();
    const picks = pool.slice(0, showcaseLimit);
    const context = shopURL({ brand: showcaseBrand, model: '', category: '', q: '' });
    const filters = ['', ...brandNames];
    const note = showcaseRoot.dataset.note || '';
    return `<div class="showcase-toolbar od-row"><div class="showcase-switch od-rail" data-seg="showcase" role="group" aria-label="Filter parts by brand">${filters.map((brand, i) => {
        const count = showcaseProducts(brand).length;
        return `<button class="showcase-choice" id="showcase-brand-${i}" type="button" data-action="home-showcase" data-brand="${esc(brand)}" aria-pressed="${brand === showcaseBrand}" aria-controls="showcase-results" aria-label="${esc(brand || 'All brands')}, ${count} parts"><span>${esc(brand || 'All')}</span><span class="showcase-count" aria-hidden="true">${count}</span></button>`;
      }).join('')}</div><span class="showcase-scope">${showcaseBrand ? 'All ' + esc(showcaseBrand) + ' models' : 'Every brand. Every model.'}</span></div>
      <div id="showcase-results" class="od-grid home-products showcase-products" data-browse-shop="${esc(context)}">${picks.map(p => productCard(p, 'linked')).join('')}</div>
      ${pool.length ? '' : '<div class="empty-state"><h3>No parts in this range yet.</h3><p>Choose another brand to explore the available parts.</p></div>'}
      <div class="showcase-footer od-stack"><p class="showcase-status" id="showcase-status" role="status" aria-live="polite" aria-atomic="true">Showing ${picks.length} of ${pool.length} parts${showcaseBrand ? ' for ' + esc(showcaseBrand) : ''}</p>${picks.length < pool.length ? '<button class="btn btn-outline" id="showcase-more" type="button" data-action="showcase-more" aria-controls="showcase-results">Show more parts</button>' : ''}</div>
      ${showcaseBrand !== 'Royal Enfield' && note ? `<p class="showcase-note">${esc(note)}</p>` : ''}`;
  }
  function refreshHomeShowcase(focusId, firstNewIndex) {
    if (!showcaseRoot) return;
    showcaseRoot.innerHTML = homeShowcase();
    syncSegments(showcaseRoot);
    if (focusId !== undefined || firstNewIndex !== undefined) animateIn(document.getElementById('showcase-results'));
    const viewLink = showcaseRoot.closest('section')?.querySelector('.section-head .text-link');
    if (viewLink) viewLink.href = shopURL({ brand: showcaseBrand, model: '', category: '', q: '' });
    if (focusId === undefined && firstNewIndex === undefined) return;
    const focusTarget = firstNewIndex === undefined ? document.getElementById(focusId) : document.getElementById('showcase-results').children[firstNewIndex];
    focusTarget?.focus({ preventScroll: true });
    if (firstNewIndex !== undefined) focusTarget?.closest('.product-card')?.scrollIntoView({ block: 'nearest', behavior: 'instant' });
    const status = document.getElementById('showcase-status');
    const message = status.textContent;
    status.textContent = '';
    requestAnimationFrame(() => { if (status.isConnected) status.textContent = message; });
  }
  function homeCategories() {
    const section = document.querySelector('[data-home-categories]');
    if (!section) return;
    const context = { brand: bike.brand, model: bike.model, q: '', sort: 'featured' };
    const descriptions = config.homeCategoryDescriptions || {};
    let customImages = {};
    try { customImages = JSON.parse(section.dataset.categoryImages || '{}') || {}; } catch (e) {}
    const contextLine = section.querySelector('[data-categories-context]');
    if (contextLine) contextLine.innerHTML = responsiveCopy(bike.brand ? `Parts that fit your ${bike.brand}${bike.model ? ` ${bike.model}` : ''}, sorted by what they do.` : 'Every part we stock, sorted by what it does.', bike.brand ? `For your ${bike.model || bike.brand}.` : 'Find parts by category.');
    const allLink = section.querySelector('[data-categories-all-link]');
    if (allLink) allLink.href = shopURL({ category: '' }, context);
    section.querySelector('.part-type-grid').innerHTML = categories.map(category => {
      const list = matchingProducts({ ...context, category });
      const example = customImages[category] || imageFor(list.find(p => p.image && p.available) || list.find(p => p.image) || {});
      const count = list.length ? `${list.length} ${list.length === 1 ? 'part' : 'parts'}` : 'No parts yet';
      return `<a class="part-type${list.length ? '' : ' is-empty'}" href="${esc(shopURL({ category }, context))}"><div class="part-type-media">${example ? imageTag(example, '') : ''}${list.length ? '' : '<span class="part-type-soon">Coming soon</span>'}<span class="part-type-count">${count}</span></div><div class="part-type-body"><div class="part-type-copy"><h3>${esc(category)}</h3><p>${esc(descriptions[category] || '')}</p></div><span class="part-type-go" aria-hidden="true">${icon('arrow')}</span></div></a>`;
    }).join('');
  }
  function rideGuide() {
    const contextRoot = document.querySelector('[data-ride-guide-context]');
    if (!contextRoot) return;
    const context = { brand: bike.brand, model: bike.model, q: '', sort: 'featured' };
    const brandEmpty = bike.brand && !products.some(p => p.brand === bike.brand);
    contextRoot.innerHTML = `${bike.brand ? `<p>${brandEmpty ? `No ${esc(bike.brand)} parts listed yet.` : `Browsing for ${esc(bike.model || bike.brand)}.`}</p>` : ''}<button type="button" class="text-link nav-link" data-action="choose-bike">${bike.brand ? 'Change your bike' : 'Choose your bike'} ${icon('arrow')}</button>`;
    document.querySelectorAll('[data-ride-category]').forEach(link => { link.href = shopURL({ category: link.dataset.rideCategory }, context); });
  }
  function heroChooser() {
    const footer = document.querySelector('[data-hero-chooser-footer]');
    if (!footer) return;
    footer.innerHTML = `${bike.brand ? `<a class="text-link" href="${esc(bike.model ? shopURL() : bikeSelectionURL(bike.brand))}">Continue with ${esc(bike.model || bike.brand)} ${icon('arrow')}</a>` : ''}<a class="text-link" href="${esc(shopURL({ brand: '', model: '' }))}">Browse all parts ${icon('arrow')}</a>`;
  }
  function renderHome() {
    if (showcaseRoot) refreshHomeShowcase();
    homeCategories();
    rideGuide();
    heroChooser();
  }

  /* Catalogue filtering */
  const hasStock = p => p.available;
  function matchesQuery(p, query) {
    const text = `${p.title} ${p.shortName} ${p.category} ${p.brand} ${p.models.join(' ')}`.toLowerCase();
    return query.toLowerCase().trim().split(/\s+/).filter(Boolean).every(term => text.includes(term));
  }
  function sortProducts(list, sort) {
    return [...list].sort((a, b) => sort === 'price-low' ? a.price - b.price : sort === 'price-high' ? b.price - a.price : sort === 'name' ? a.title.localeCompare(b.title) : Number(hasStock(b)) - Number(hasStock(a)));
  }
  function matchingProducts(f, pool = products) {
    return sortProducts(pool.filter(p => (!f.brand || p.brand === f.brand) && (!f.model || p.models.includes(f.model)) && (!f.category || p.category === f.category) && matchesQuery(p, f.q || '')), f.sort);
  }
  function universalProducts(f, pool = products) {
    return sortProducts(pool.filter(p => p.brand === 'Universal' && (!f.category || p.category === f.category) && matchesQuery(p, f.q || '')), f.sort);
  }

  /* Bike chooser pages */
  function bikeSelection(brand) {
    if (!Object.hasOwn(bikes, brand)) return `<section class="container section"><div class="empty-state"><h1>Choose your bike brand.</h1><p>Select a brand to see its bike models.</p><div class="empty-actions od-cluster">${Object.keys(bikes).map(name => `<a class="btn btn-outline" href="${esc(bikeSelectionURL(name))}">${esc(name)} ${icon('arrow')}</a>`).join('')}</div><a class="text-link" href="${esc(shopURL({ brand: '', model: '', category: '', q: '' }))}">Browse all parts ${icon('arrow')}</a></div></section>`;
    const noListings = !products.some(p => p.brand === brand);
    return `<section class="container model-choice-page" aria-labelledby="model-choice-title">
      <nav class="breadcrumb" aria-label="Breadcrumb"><a href="${esc(rootURL())}">Home</a>${icon('chevron')}<a href="${esc(rootURL('bike-finder'))}">Brands</a>${icon('chevron')}<span aria-current="page">${esc(brand)}</span></nav>
      <header class="model-choice-header od-row"><div class="od-stack od-fill"><p class="eyebrow">${esc(brand)}</p><h1 id="model-choice-title">Which bike do you ride?</h1><p>${responsiveCopy('Choose your model to see the parts listed for it.', 'Pick your model to see its parts.')}</p></div><a class="text-link od-fixed" href="${esc(rootURL('bike-finder'))}">Change brand ${icon('arrow')}</a></header>
      ${noListings ? `<p class="model-choice-notice">No ${esc(brand)} parts are listed yet. You can still select your bike and explore universal accessories separately.</p>` : ''}
      <div class="model-choice-grid od-grid">${bikes[brand].map((model, i) => {
        const photo = bikePhoto(brand, model);
        const count = products.filter(p => p.brand === brand && p.models.includes(model)).length;
        const selected = bike.brand === brand && bike.model === model;
        return `<a class="bike-model-card od-stack" id="bike-choice-${i}" href="${esc(shopURL({ brand, model, category: '', q: '', sort: 'featured' }, undefined, routes.all))}" data-bike-brand="${esc(brand)}" data-bike-model="${esc(model)}" data-saved="${selected}" aria-labelledby="bike-name-${i}" aria-describedby="bike-count-${i}${selected ? ` bike-saved-${i}` : ''}">
          <div class="bike-model-media">${imageTag(photo, `${brand} ${model}, side profile`, i === 0 ? 'fetchpriority="high"' : '')}</div>
          <div class="bike-model-body od-stack"><div class="od-row"><h2 class="od-fill" id="bike-name-${i}">${esc(model)}</h2><span class="bike-model-arrow od-fixed" aria-hidden="true">${icon('arrow')}</span></div><div class="bike-model-meta od-cluster"><p id="bike-count-${i}">${count ? `${count} ${count === 1 ? 'part' : 'parts'} listed` : 'No parts listed yet'}</p>${selected ? `<span class="bike-saved od-row" id="bike-saved-${i}">${icon('check')}Saved bike</span>` : ''}</div></div>
        </a>`;
      }).join('')}</div>
      <section class="model-choice-explore" aria-labelledby="explore-title">
        <h2 class="model-choice-explore-title" id="explore-title">Prefer to explore everything?</h2>
        <nav class="model-choice-explore-links" aria-label="Browse without selecting a bike">
          <a class="explore-tile" href="${esc(rootURL('best-sellers'))}"><span class="explore-tile-copy"><strong>Best sellers</strong><span>Riders’ top picks</span></span>${icon('arrow')}</a>
          <a class="explore-tile" href="${esc(shopURL({ brand: '', model: '', category: '', q: '', sort: 'featured' }))}"><span class="explore-tile-copy"><strong>All parts</strong><span>Full catalogue</span></span>${icon('arrow')}</a>
        </nav>
        <p class="model-choice-fitment">${icon('info')}<span>${responsiveCopy('Check mounting points and fitment on each product page.', 'Check fitment on each product page.')}</span></p>
      </section>
    </section>`;
  }
  function renderBikes() {
    const root = document.querySelector('[data-bikes-root]');
    if (!root) return;
    const brand = selectionBrand();
    const model = selectionModel();
    if (model) { setBike(brand, model); location.replace(shopURL({ brand, model, category: '', q: '', sort: 'featured' }, undefined, routes.all)); return; }
    root.innerHTML = bikeSelection(brand);
    document.title = `${brand || 'Choose your'} bike | ${shopName}`;
  }

  /* Collection page */
  const shopRoot = document.querySelector('[data-shop-root]');
  const collectionPool = (() => {
    if (!shopRoot) return products;
    let handles = null;
    try { handles = JSON.parse(shopRoot.querySelector('[data-collection-handles]')?.textContent || 'null'); } catch { handles = null; }
    return Array.isArray(handles) ? handles.map(findProduct).filter(Boolean) : products;
  })();
  const collectionTitle = shopRoot?.dataset.collectionTitle || '';
  function shop() {
    const f = getFilters();
    const pool = collectionPool;
    const list = matchingProducts(f, pool);
    const universal = f.brand ? universalProducts(f, pool) : [];
    const emptyBrand = Boolean(f.brand) && !pool.some(p => p.brand === f.brand);
    const title = f.model ? `${f.model} parts` : f.brand ? `${f.brand} parts` : collectionTitle || 'All parts';
    const eyebrow = f.model ? 'YOUR BIKE. YOUR COLLECTION.' : f.brand ? 'YOUR BRAND. YOUR COLLECTION.' : 'THE COMPLETE COLLECTION';
    const scope = f.model || f.brand || 'all';
    const count = n => `${n} ${n === 1 ? 'part' : 'parts'}`;
    const bikeChips = f.brand
      ? [`<a class="shop-chip" href="${esc(shopURL({ brand: '', model: '', category: f.category, q: '' }, f))}">All bikes</a>`,
        `<a class="shop-chip" href="${esc(shopURL({ brand: f.brand, model: '' }, f))}" ${!f.model ? 'aria-current="true"' : ''}>All ${esc(f.brand)}</a>`,
        ...bikes[f.brand].map(model => {
          const photo = bikePhoto(f.brand, model);
          return `<a class="shop-chip shop-chip-bike" href="${esc(shopURL({ brand: f.brand, model }, f))}" data-bike-brand="${esc(f.brand)}" data-bike-model="${esc(model)}" ${f.model === model ? 'aria-current="true"' : ''}>${photo ? `<img src="${esc(photo.src)}" width="${photo.width}" height="${photo.height}" alt="" loading="lazy" decoding="async">` : ''}<span>${esc(model)}</span></a>`;
        })]
      : [`<a class="shop-chip" href="${esc(shopURL({ brand: '', model: '' }, f))}" aria-current="true">All bikes</a>`,
        ...Object.keys(bikes).map(brand => `<a class="shop-chip" href="${esc(shopURL({ brand, model: '' }, f))}">${esc(brand)}</a>`)];
    const typeChips = ['', ...categories].map((category, i) => {
      const n = matchingProducts({ ...f, category, q: '' }, pool).length;
      return `<button type="button" class="shop-chip" id="category-${category ? i - 1 : 'all'}" data-action="part-category" data-category="${esc(category)}" aria-pressed="${f.category === category}">${esc(category || 'All types')}<span class="shop-chip-count">${n}</span></button>`;
    }).join('');
    return `<nav class="breadcrumb" aria-label="Breadcrumb"><a href="${esc(rootURL())}">Home</a>${icon('chevron')}${f.brand ? `<a href="${esc(bikeSelectionURL(f.brand))}">${esc(f.brand)}</a>${icon('chevron')}` : ''}<a href="${esc(shopURL({ category: '', q: '' }, f))}">${esc(f.model || 'All parts')}</a>${f.category ? `${icon('chevron')}<span aria-current="page">${esc(f.category)}</span>` : ''}</nav>
      <header class="shop-head"><div class="shop-head-copy"><p class="eyebrow">${eyebrow}</p><h1>${esc(title)}</h1></div><div class="shop-meta"><p class="shop-count" aria-live="polite">${count(list.length)}</p><label class="sr-only" for="sort">Sort by</label><select id="sort" class="shop-sort" data-action="sort">${[['featured', 'Recommended'], ['price-low', 'Price: low to high'], ['price-high', 'Price: high to low'], ['name', 'Name']].map(([value, label]) => `<option value="${value}" ${f.sort === value ? 'selected' : ''}>${label}</option>`).join('')}</select></div></header>
      <div class="shop-chip-row shop-bike-row" data-seg="shop-bike" role="group" aria-label="Bike">${bikeChips.join('')}</div>
      <div class="shop-type-anchor" aria-hidden="true"></div>
      <div class="shop-chip-row shop-type-bar" data-seg="shop-type" role="group" aria-label="Part type">${typeChips}</div>
      <form class="shop-search" data-form="collection-search" role="search"><label class="sr-only" for="collection-query">Search ${esc(scope)} parts</label>${icon('search')}<input type="search" id="collection-query" name="q" value="${esc(f.q)}" placeholder="Search parts" autocomplete="off"><button type="submit" class="sr-only">Search</button></form>
      ${f.q ? `<div class="active-filters"><button class="filter-chip" data-action="remove-filter" data-key="q" aria-label="Remove search ${esc(f.q)}"><span>Search: “${esc(f.q)}”</span>${icon('close')}</button></div>` : ''}
      <section class="collection-results" aria-labelledby="results-title"${f.model ? ' data-model' : ''}><h2 class="sr-only" id="results-title" tabindex="-1">${f.q ? `Search results for ${esc(f.q)}` : esc(f.category || title)}</h2>
      ${list.length ? `<div class="od-grid collection-products">${list.map(p => productCard(p, 'quick')).join('')}</div>` : `<div class="empty-state"><h2>${emptyBrand ? `No ${esc(f.brand)} parts listed yet.` : 'No listings for this selection.'}</h2><p>${emptyBrand ? 'Browse the current catalogue to explore available parts.' : 'Try another part type or clear your search.'}${universal.length ? ' Universal options are shown separately below and need a fitment check.' : ''}</p><div class="empty-actions od-cluster">${emptyBrand ? `<a class="btn btn-dark" href="${esc(shopURL({ brand: '', model: '', category: '', q: '' }))}">Browse all parts ${icon('arrow')}</a>` : `<button class="btn btn-dark" data-action="clear-filters">Clear part filters</button>`}</div></div>`}
      </section>
      ${universal.length ? `<section class="universal-options" aria-labelledby="universal-title"><div class="result-heading od-row"><div class="od-field od-fill"><p class="eyebrow">FITS ANY BIKE</p><h2 id="universal-title">Universal accessories</h2><p>These ${f.category ? esc(f.category.toLowerCase()) + ' ' : ''}parts aren’t made for one model. Check mounts and dimensions before choosing.</p></div><span class="product-badge">Check fitment</span></div><div class="od-grid collection-products">${universal.map(p => productCard(p, 'quick')).join('')}</div></section>` : ''}`;
  }
  function renderShop() {
    if (!shopRoot) return;
    const f = getFilters();
    rememberShop(currentPath());
    shopRoot.innerHTML = shop();
    syncSegments(shopRoot);
    if (!firstRender) shopRoot.querySelectorAll('.collection-products').forEach(animateIn);
    shopRoot.querySelectorAll('.shop-chip-row').forEach(row => {
      const active = row.querySelector('[aria-current="true"],[aria-pressed="true"]');
      if (active && row.scrollWidth > row.clientWidth) row.scrollLeft = Math.max(0, active.offsetLeft - row.offsetLeft - (row.clientWidth - active.offsetWidth) / 2);
    });
    document.title = `${f.model || f.brand || collectionTitle || 'Shop parts'} | ${shopName}`;
  }

  /* Product page */
  function bikeName(selected = bike) {
    return [selected.brand, selected.model].filter(Boolean).join(' · ');
  }
  function cleanBikeText(value) {
    return typeof value === 'string' ? value.trim().replace(/\s+/g, ' ').slice(0, 120) : '';
  }
  function normalizeProductBike(value) {
    if (!value || typeof value !== 'object' || !['none', 'listed', 'other'].includes(value.mode)) return null;
    const empty = { mode: 'none', brand: '', model: '', otherName: '' };
    if (value.mode === 'none') return empty;
    if (value.mode === 'other') return { ...empty, mode: 'other', otherName: cleanBikeText(value.otherName) };
    const brand = cleanBikeText(value.brand), model = cleanBikeText(value.model);
    return brand && model ? { ...empty, mode: 'listed', brand, model } : null;
  }
  function productBikeName(selected) {
    if (!selected) return 'Bike not recorded';
    if (selected.mode === 'none') return 'No bike selected';
    return selected.mode === 'listed' ? bikeName(selected) : selected.otherName || 'Other bike';
  }
  const listJoin = items => items.length > 1 ? `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}` : items[0] || '';
  function shopperFitment(p) {
    const made = listJoin(p.models);
    const brandModels = made ? `${p.brand} ${made}` : '';
    if (p.brand === 'Universal') {
      return { selected: normalizeProductBike(bike.model ? { mode: 'other', otherName: bikeName() } : { mode: 'none' }), fit: { kind: 'unknown', title: 'Universal fit', text: 'Fits most bikes. Check mounts and size.' }, headline: 'Fits most bikes', detail: 'Check the mounting points on your bike before ordering.' };
    }
    const yourBike = `${bike.brand} ${bike.model}`;
    if (bike.model && bike.brand === p.brand && p.models.includes(bike.model)) {
      return { selected: normalizeProductBike({ mode: 'listed', brand: bike.brand, model: bike.model }), fit: { kind: 'listed', title: `Fits ${bike.model}`, text: 'Made for this bike.' }, headline: `Fits your ${yourBike}`, detail: 'Made for this bike.' };
    }
    if (bike.model) {
      return { selected: normalizeProductBike({ mode: 'other', otherName: bikeName() }), fit: { kind: 'mismatch', title: `Doesn't fit ${bike.model}`, text: brandModels ? `Made for ${brandModels}.` : 'Ask us to confirm the fit.' }, headline: `Doesn’t fit your ${yourBike}`, detail: made ? 'Made for the bikes above.' : 'Ask us to confirm the fit.' };
    }
    return { selected: normalizeProductBike({ mode: 'none' }), fit: { kind: 'unknown', title: brandModels ? `Made for ${brandModels}` : 'Fitment to confirm', text: 'No bike was chosen.' }, headline: made ? 'Which bike do you ride?' : 'Fitment to confirm', detail: made ? 'Tap your bike above to check the fit.' : 'Ask us to confirm the fit.' };
  }
  const productData = onProductPage ? readJSON('mg-product-json') : null;
  const productPage = productData ? {
    ...(findProduct(productData.id) || {}),
    ...productData,
    brand: brandNames.includes(productData.vendor) ? productData.vendor : 'Universal',
    models: Array.isArray(productData.models) ? productData.models : []
  } : null;
  const productState = productPage ? { variant: String(productPage.selectedVariant), qty: 1, image: 0 } : null;
  function fitmentPanel(p) {
    const { fit, headline } = shopperFitment(p);
    const universal = p.brand === 'Universal';
    const change = '<button type="button" class="pdp-fit-help" data-action="choose-bike">Change</button>';
    let body;
    if (universal) {
      body = `<p class="pdp-fit-row">${icon('info')}<strong id="product-fitment-status">Fits most bikes · check mounts</strong><button type="button" class="pdp-fit-help" data-action="help">Fitment help</button></p>`;
    } else if (fit.kind === 'listed' || fit.kind === 'mismatch') {
      body = `<p class="pdp-fit-row">${icon(fit.kind === 'listed' ? 'check' : 'close')}<strong id="product-fitment-status" role="status" aria-live="polite">${esc(headline)}</strong>${change}</p>`
        + (fit.kind === 'mismatch' && p.models.length ? `<p class="pdp-fit-note">Made for ${esc(listJoin(p.models))}</p>` : '');
    } else if (p.models.length) {
      body = `<div class="pdp-fit-row pdp-fit-pick"><span class="pdp-fit-label" id="fit-label">Your bike:</span><div class="pdp-fit-pills" role="group" aria-labelledby="fit-label">${p.models.map(model => {
          const photo = bikePhoto(p.brand, model);
          return `<button type="button" class="shop-chip shop-chip-bike pdp-fit-pill" data-action="fit-pick" data-brand="${esc(p.brand)}" data-model="${esc(model)}" aria-label="${esc(`${p.brand} ${model}`)}, set as my bike">${photo ? `<img src="${esc(photo.src)}" width="${photo.width}" height="${photo.height}" alt="" loading="lazy" decoding="async">` : ''}<span>${esc(model)}</span></button>`;
        }).join('')}<button type="button" class="pdp-fit-help pdp-fit-other-link" data-action="choose-bike">Other</button></div></div><p class="sr-only" id="product-fitment-status" role="status" aria-live="polite">Tap your bike to check the fit.</p>`;
    } else {
      body = `<p class="pdp-fit-row">${icon('info')}<strong id="product-fitment-status">Ask us to confirm the fit</strong><button type="button" class="pdp-fit-help" data-action="help">Fitment help</button></p>`;
    }
    return `<section class="pdp-fit pdp-fit-compact" aria-label="Fitment" data-fitment-panel data-fit="${fit.kind}">${body}</section>`;
  }
  function relatedProducts(p) {
    const selected = bike.model ? bike : null;
    const relatedBrand = selected ? selected.brand : p.brand;
    const relatedModels = selected ? [selected.model] : p.models;
    const related = products.filter(other => other.id !== p.id && other.brand === relatedBrand && (relatedBrand === 'Universal' ? other.category === p.category : !relatedModels.length || other.models.some(model => relatedModels.includes(model))))
      .sort((a, b) => Number(b.category === p.category) - Number(a.category === p.category) || Number(hasStock(b)) - Number(hasStock(a))).slice(0, 4);
    if (!related.length) return '';
    return `<section class="section related-section"><div class="container"><div class="section-head"><div><h2>${relatedBrand === 'Universal' ? 'More universal options' : 'More for your ride'}</h2><p>${relatedBrand === 'Universal' ? 'Other parts that fit most bikes.' : `More parts for ${esc(selected?.model || p.models.join(' / ') || relatedBrand)}.`}</p></div></div><div class="od-grid home-products">${related.map(item => productCard(item, 'quick')).join('')}</div></div></section>`;
  }
  function renderProductDynamic() {
    const p = productPage;
    if (!p) return;
    const panel = document.querySelector('[data-fitment-panel]');
    if (panel) panel.outerHTML = fitmentPanel(p);
    const related = document.querySelector('[data-related-root]');
    if (related) related.innerHTML = relatedProducts(p);
    const shopLink = document.querySelector('[data-product-shop-link]');
    if (shopLink && validShop(storedShop)) {
      shopLink.href = lastShop;
      shopLink.textContent = `${getFilters(queryOf(lastShop)).brand || 'All'} parts`;
    }
    updateHeader();
  }
  function rememberPurchase() {
    const form = document.querySelector('[data-form="purchase"]');
    if (!form || !productState) return;
    const qty = Number(form.elements.quantity.value);
    if (Number.isInteger(qty) && qty >= 1 && qty <= 99) productState.qty = qty;
    const variant = form.elements.namedItem('id')?.value;
    if (productPage.variants.some(v => String(v.id) === variant)) productState.variant = variant;
  }
  const priceMarkup = v => `<span class="price od-nowrap">${money(v.price)}</span>${v.compareAt > v.price ? `<s class="compare-price od-nowrap">${money(v.compareAt)}</s>` : ''}${offBadge(v.price, v.compareAt)}`;
  function syncPurchaseControls() {
    const form = document.querySelector('[data-form="purchase"]');
    const p = productPage;
    if (!form || !p) return;
    rememberPurchase();
    const v = p.variants.find(item => String(item.id) === form.elements.namedItem('id')?.value);
    if (!v) return;
    const qty = Number(form.elements.quantity.value);
    const valid = Number.isInteger(qty) && qty >= 1 && qty <= 99;
    document.getElementById('product-price').innerHTML = priceMarkup(v);
    const save = document.getElementById('product-save');
    if (save) { save.hidden = !(v.compareAt > v.price); save.textContent = v.compareAt > v.price ? `You save ${money(v.compareAt - v.price)}` : ''; }
    const stock = document.getElementById('product-availability'); stock.textContent = v.available ? 'In stock' : 'Out of stock'; stock.dataset.available = String(v.available);
    const sku = document.getElementById('product-sku'); sku.textContent = v.sku ? `SKU: ${v.sku}` : ''; sku.hidden = !v.sku;
    const add = document.getElementById('add-to-cart');
    add.disabled = !v.available;
    add.innerHTML = `${icon(v.available ? 'bag-plus' : 'bag')}${v.available ? 'Add to cart' : 'Out of stock'}`;
    const sticky = document.getElementById('mobile-add-to-cart'); sticky.disabled = !v.available; sticky.innerHTML = v.available ? `${icon('bag-plus')}Add to cart` : 'Out of stock';
    document.getElementById('mobile-purchase-price').textContent = money(v.price * (valid ? qty : 1));
    document.getElementById('mobile-purchase-quantity').textContent = valid ? `Total for ${qty} ${qty === 1 ? 'item' : 'items'}` : 'Check quantity';
    form.querySelector('[data-action="quantity-minus"]').disabled = valid && qty <= 1;
    form.querySelector('[data-action="quantity-plus"]').disabled = valid && qty >= 99;
  }
  function syncPurchaseBar() {
    const bar = document.getElementById('mobile-purchase');
    const action = document.getElementById('add-to-cart');
    if (!bar || !action) { document.documentElement.style.setProperty('--purchase-space', '0px'); return; }
    const rect = action.getBoundingClientRect();
    const viewport = window.visualViewport;
    const visibleBottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
    const visibleTop = siteHeader ? siteHeader.getBoundingClientRect().bottom : 0;
    const fieldActive = document.activeElement?.matches('input,select,textarea');
    const show = matchMedia('(max-width:767px)').matches && !document.querySelector('dialog[open]') && !fieldActive && (rect.bottom <= visibleTop || rect.top >= visibleBottom);
    bar.hidden = !show;
    document.documentElement.style.setProperty('--purchase-space', show ? `${bar.getBoundingClientRect().height}px` : '0px');
  }
  function setupPurchaseBar() {
    purchaseResizeObserver?.disconnect();
    const bar = document.getElementById('mobile-purchase');
    if (bar && 'ResizeObserver' in window) { purchaseResizeObserver = new ResizeObserver(syncPurchaseBar); purchaseResizeObserver.observe(bar); }
    syncPurchaseControls(); syncPurchaseBar();
  }
  const galleryZoom = { slide: null, scale: 1, x: 0, y: 0 };
  function hideGalleryHint() { document.getElementById('gallery-hint')?.classList.add('is-hidden'); }
  function applyGalleryZoom(slide, scale, x, y, animate) {
    const img = slide?.querySelector('img');
    if (!img) return;
    const maxX = (scale - 1) * slide.clientWidth / 2;
    const maxY = (scale - 1) * slide.clientHeight / 2;
    x = Math.max(-maxX, Math.min(maxX, x));
    y = Math.max(-maxY, Math.min(maxY, y));
    Object.assign(galleryZoom, { slide, scale, x, y });
    img.style.transformOrigin = '';
    img.style.transition = animate ? 'transform 220ms ease-out' : 'none';
    img.style.transform = scale > 1 ? `translate(${x}px, ${y}px) scale(${scale})` : '';
    slide.classList.toggle('is-zoomed', scale > 1);
    document.getElementById('gallery-slides')?.classList.toggle('is-zoomed', scale > 1);
    if (scale > 1) hideGalleryHint();
  }
  function resetGalleryZoom(animate = true) {
    if (galleryZoom.slide && galleryZoom.scale !== 1) applyGalleryZoom(galleryZoom.slide, 1, 0, 0, animate);
  }
  function zoomGalleryAt(slide, clientX, clientY, scale) {
    const r = slide.getBoundingClientRect();
    const px = clientX - (r.left + r.width / 2), py = clientY - (r.top + r.height / 2);
    applyGalleryZoom(slide, scale, px * (1 - scale), py * (1 - scale), true);
  }
  function selectGallery(p, index, scroll = true) {
    if (!p.images[index]) return;
    if (index !== productState.image) resetGalleryZoom(false);
    productState.image = index;
    const slides = document.getElementById('gallery-slides');
    if (scroll && slides) slides.scrollTo({ left: slides.clientWidth * index, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    const counter = document.getElementById('gallery-counter');
    if (counter) counter.textContent = `${index + 1} / ${p.images.length}`;
    const prev = document.querySelector('.pdp-arrow-prev'), next = document.querySelector('.pdp-arrow-next');
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === p.images.length - 1;
    document.querySelectorAll('[data-action="gallery"]').forEach(button => {
      const active = Number(button.dataset.index) === index;
      button.setAttribute('aria-pressed', String(active));
      if (active) button.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    });
  }
  function setupGallery() {
    const slides = document.getElementById('gallery-slides');
    if (!slides || !productPage) return;
    setTimeout(hideGalleryHint, 6000);
    let frame = null;
    slides.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const index = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
        if (index !== productState.image) selectGallery(productPage, index, false);
      });
    }, { passive: true });
    slides.addEventListener('keydown', e => {
      const slide = slides.children[productState.image];
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        selectGallery(productPage, Math.max(0, Math.min(productPage.images.length - 1, productState.image + (e.key === 'ArrowRight' ? 1 : -1))));
      } else if ((e.key === 'Enter' || e.key === ' ') && slide) {
        e.preventDefault();
        if (galleryZoom.slide === slide && galleryZoom.scale > 1) resetGalleryZoom();
        else applyGalleryZoom(slide, 2, 0, 0, true);
      } else if (e.key === 'Escape') resetGalleryZoom();
    });
    const touch = { mode: null, startX: 0, startY: 0, startTime: 0, lastTap: 0, lastX: 0, lastY: 0, d0: 0, s0: 1, x0: 0, y0: 0, mx: 0, my: 0, slide: null };
    const distance = t => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
    slides.addEventListener('touchstart', e => {
      const slide = e.target.closest('.pdp-slide');
      if (!slide) return;
      if (e.touches.length === 2) {
        e.preventDefault();
        const r = slide.getBoundingClientRect();
        const zoomed = galleryZoom.slide === slide;
        Object.assign(touch, { mode: 'pinch', slide, d0: distance(e.touches), s0: zoomed ? galleryZoom.scale : 1, x0: zoomed ? galleryZoom.x : 0, y0: zoomed ? galleryZoom.y : 0,
          mx: (e.touches[0].clientX + e.touches[1].clientX) / 2 - (r.left + r.width / 2), my: (e.touches[0].clientY + e.touches[1].clientY) / 2 - (r.top + r.height / 2) });
        hideGalleryHint();
      } else if (e.touches.length === 1) {
        const t = e.touches[0];
        Object.assign(touch, { startX: t.clientX, startY: t.clientY, startTime: Date.now(), slide });
        if (galleryZoom.slide === slide && galleryZoom.scale > 1) {
          e.preventDefault();
          Object.assign(touch, { mode: 'pan', x0: galleryZoom.x, y0: galleryZoom.y });
        } else touch.mode = 'tap';
      }
    }, { passive: false });
    slides.addEventListener('touchmove', e => {
      if (touch.mode === 'pinch' && e.touches.length === 2) {
        e.preventDefault();
        const scale = Math.max(1, Math.min(4, touch.s0 * distance(e.touches) / touch.d0));
        const ratio = scale / touch.s0;
        applyGalleryZoom(touch.slide, scale, touch.mx - (touch.mx - touch.x0) * ratio, touch.my - (touch.my - touch.y0) * ratio, false);
      } else if (touch.mode === 'pan' && e.touches.length === 1) {
        e.preventDefault();
        const t = e.touches[0];
        applyGalleryZoom(touch.slide, galleryZoom.scale, touch.x0 + t.clientX - touch.startX, touch.y0 + t.clientY - touch.startY, false);
      } else if (touch.mode === 'tap' && e.touches.length === 1) {
        const t = e.touches[0];
        if (Math.hypot(t.clientX - touch.startX, t.clientY - touch.startY) > 10) touch.mode = null;
      }
    }, { passive: false });
    slides.addEventListener('touchend', e => {
      if (touch.mode === 'pinch') {
        if (e.touches.length === 0) { if (galleryZoom.scale < 1.1) resetGalleryZoom(); touch.mode = null; }
        return;
      }
      if (touch.mode === 'pan' || touch.mode === 'tap') {
        const quick = Date.now() - touch.startTime < 300;
        const moved = Math.hypot(e.changedTouches[0].clientX - touch.startX, e.changedTouches[0].clientY - touch.startY) > 10;
        if (quick && !moved) {
          const now = Date.now();
          if (now - touch.lastTap < 320 && Math.hypot(touch.startX - touch.lastX, touch.startY - touch.lastY) < 30) {
            e.preventDefault();
            if (galleryZoom.slide === touch.slide && galleryZoom.scale > 1) resetGalleryZoom();
            else zoomGalleryAt(touch.slide, touch.startX, touch.startY, 2.5);
            touch.lastTap = 0;
          } else Object.assign(touch, { lastTap: now, lastX: touch.startX, lastY: touch.startY });
        }
      }
      touch.mode = null;
    });
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      slides.addEventListener('mousemove', e => {
        const slide = e.target.closest('.pdp-slide');
        const img = slide?.querySelector('img');
        if (!img || (galleryZoom.slide === slide && galleryZoom.scale > 1)) return;
        const r = slide.getBoundingClientRect();
        img.style.transition = 'none';
        img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
        img.style.transform = 'scale(2.2)';
        slide.classList.add('is-hover-zoom');
        hideGalleryHint();
      });
      slides.addEventListener('mouseleave', () => {
        slides.querySelectorAll('.is-hover-zoom').forEach(slide => {
          slide.classList.remove('is-hover-zoom');
          const img = slide.querySelector('img');
          if (img) { img.style.transform = ''; img.style.transformOrigin = ''; }
        });
      });
      slides.addEventListener('mouseover', e => {
        slides.querySelectorAll('.is-hover-zoom').forEach(slide => {
          if (slide.contains(e.target)) return;
          slide.classList.remove('is-hover-zoom');
          const img = slide.querySelector('img');
          if (img) { img.style.transform = ''; img.style.transformOrigin = ''; }
        });
      });
    }
    window.addEventListener('resize', () => resetGalleryZoom(false), { passive: true });
  }
  function paintLightbox() {
    if (!lightboxState || !productPage) return;
    const p = productPage; const im = p.images[lightboxState.index];
    if (!im) return;
    const stage = document.getElementById('lightbox-stage');
    stage.classList.toggle('is-zoomed', lightboxState.zoomed);
    stage.innerHTML = `<div class="lightbox-picture">${imageTag(im, `${p.title}, image ${lightboxState.index + 1}`, 'fetchpriority="high"')}</div>`;
    stage.scrollTo({ top: 0, left: 0 });
    document.getElementById('lightbox-caption').textContent = `${p.shortName} — image ${lightboxState.index + 1} of ${p.images.length}`;
    const zoom = document.getElementById('lightbox-zoom'); zoom.textContent = lightboxState.zoomed ? 'Fit image' : 'Zoom in'; zoom.setAttribute('aria-pressed', String(lightboxState.zoomed));
    document.getElementById('lightbox-previous').disabled = lightboxState.index === 0;
    document.getElementById('lightbox-next').disabled = lightboxState.index === p.images.length - 1;
  }
  function moveLightbox(delta) {
    if (!lightboxState || !productPage) return;
    const p = productPage;
    lightboxState.index = Math.max(0, Math.min(p.images.length - 1, lightboxState.index + delta)); lightboxState.zoomed = false;
    selectGallery(p, lightboxState.index); paintLightbox();
  }

  /* Cart */
  const cartURL = path => `${path}.js`;
  async function refreshCart() {
    const response = await fetch(cartURL(routes.cart), { headers: { Accept: 'application/json' } });
    cart = await response.json();
    updateHeader();
    return cart;
  }
  async function changeCartLine(key, quantity) {
    const response = await fetch(cartURL(routes.cartChange), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    if (!response.ok) { const error = await response.json().catch(() => ({})); notify(error.description || 'Your cart could not be updated.'); return refreshCart(); }
    cart = await response.json();
    cartChanged = true;
    updateHeader();
    return cart;
  }
  function cartFitBadge(item) {
    const props = item.properties || {};
    const kind = props.Bike ? props._fit_kind || 'unknown' : 'unknown';
    const title = props.Bike ? props._fit_title || 'Check fitment' : 'Check fitment';
    const label = kind === 'unknown' && title !== 'Universal fit' ? 'Check fitment' : title;
    return `<span class="cart-badge cart-badge-fit" data-fit="${esc(kind)}" title="${esc(props._fit_text || '')}">${kind === 'listed' ? icon('check') : kind === 'mismatch' ? icon('close') : ''}${esc(label)}</span>`;
  }
  function cartCompareAt(item) {
    const p = findProduct(item.handle);
    return p && String(p.variantId) === String(item.variant_id) && p.compareAt > item.final_price / 100 ? p.compareAt : 0;
  }
  function cartLine(item) {
    const p = findProduct(item.handle);
    const name = p?.shortName || item.product_title;
    const key = item.key;
    const image = p?.image || (item.image ? { src: item.image, width: 600, height: 600 } : null);
    const compareAt = cartCompareAt(item);
    const unit = item.final_price / 100;
    const off = compareAt ? percentOff(unit, compareAt) : 0;
    return `<article class="cart-line" data-cart-key="${esc(key)}">
      <a class="cart-line-img" href="${esc(item.url)}" tabindex="-1" aria-hidden="true">${imageTag(image, '')}</a>
      <div class="cart-line-main">
        <div class="cart-line-top"><a class="cart-line-name" href="${esc(item.url)}">${esc(name)}</a><button type="button" class="cart-line-remove" data-action="remove-item" data-key="${esc(key)}" aria-label="Remove ${esc(name)}">${icon('trash')}</button></div>
        <div class="cart-line-badges">${cartFitBadge(item)}${item.product_has_only_default_variant ? '' : `<span class="cart-badge">${esc(item.variant_title)}</span>`}${off >= 1 ? `<span class="cart-badge cart-badge-off">${off}% OFF</span>` : ''}</div>
        <div class="cart-line-bottom">
          <div class="quantity-control cart-qty"><button type="button" data-action="cart-minus" data-key="${esc(key)}" aria-label="Decrease quantity of ${esc(name)}" ${item.quantity <= 1 ? 'disabled' : ''}>${icon('minus')}</button><input type="number" inputmode="numeric" min="1" max="99" value="${item.quantity}" aria-label="Quantity of ${esc(name)}" data-action="cart-quantity" data-key="${esc(key)}"><button type="button" data-action="cart-plus" data-key="${esc(key)}" aria-label="Increase quantity of ${esc(name)}" ${item.quantity >= 99 ? 'disabled' : ''}>${icon('plus')}</button></div>
          <div class="cart-line-price"><span><strong>${money(item.final_line_price / 100)}</strong>${compareAt ? `<s>${money(compareAt * item.quantity)}</s>` : ''}</span>${item.quantity > 1 ? `<small>${money(unit)} each</small>` : ''}</div>
        </div>
      </div>
    </article>`;
  }
  function cartTotals() {
    const count = cart.item_count || 0;
    const subtotal = (cart.total_price || 0) / 100;
    const savings = (cart.items || []).reduce((sum, item) => { const c = cartCompareAt(item); return sum + (c ? (c - item.final_price / 100) * item.quantity : 0); }, 0);
    const mismatches = (cart.items || []).filter(item => item.properties?._fit_kind === 'mismatch').length;
    return { count, subtotal, savings, mismatches };
  }
  function cartWarning() {
    const { mismatches } = cartTotals();
    return mismatches ? `<p class="cart-warning">${icon('info')}<span>${mismatches === 1 ? '1 part doesn’t' : `${mismatches} parts don’t`} fit the bike chosen for ${mismatches === 1 ? 'it' : 'them'}. Check before checkout.</span></p>` : '';
  }
  function cartSummary() {
    const { count, subtotal, savings } = cartTotals();
    return `<div class="cart-summary">
      <div class="cart-sum-row"><span>Subtotal (${count} ${count === 1 ? 'item' : 'items'})</span><strong>${money(subtotal)}</strong></div>
      ${savings > 0 ? `<div class="cart-sum-row cart-sum-save"><span>You save</span><span>${money(savings)}</span></div>` : ''}
      <p class="cart-sum-note">${config.taxesIncluded ? 'Tax included.' : 'Taxes calculated at checkout.'} Shipping calculated at checkout.</p>
      <a class="btn cart-checkout" href="/checkout">${icon('lock')}Checkout · ${money(subtotal)}</a>
      <p class="cart-secure">${icon('shield')}Secure checkout</p>
    </div>`;
  }
  function cartEmpty(level = 'h3') {
    const label = bike.model ? `Shop parts for your ${bike.model}` : 'Browse parts';
    return `<div class="cart-empty">${icon('bag')}<${level}>Your cart is empty</${level}><p>Parts for your bike are a tap away.</p><a class="btn btn-dark" href="${esc(shopURL())}">${esc(label)} ${icon('arrow')}</a></div>`;
  }
  function renderCart() {
    const dialog = document.getElementById('cart-dialog');
    const count = cart.item_count || 0;
    document.querySelectorAll('[data-cart-title-count]').forEach(el => { el.textContent = count ? `· ${count}` : ''; });
    if (dialog) {
      const bodyEl = dialog.querySelector('.dialog-body');
      const footer = dialog.querySelector('.dialog-footer');
      if (!cart.items?.length) { bodyEl.innerHTML = cartEmpty(); footer.hidden = true; }
      else { footer.hidden = false; bodyEl.innerHTML = cartWarning() + cart.items.map(cartLine).join(''); footer.innerHTML = cartSummary(); }
    }
    const page = document.querySelector('[data-cart-page]');
    if (page) {
      page.innerHTML = cart.items?.length
        ? `<header class="shop-head"><div class="shop-head-copy"><h1>Your cart</h1></div><div class="shop-meta"><p class="shop-count">${count} ${count === 1 ? 'item' : 'items'}</p></div></header>
           <div class="cart-page-layout"><div class="cart-page-lines">${cartWarning()}${cart.items.map(cartLine).join('')}<a class="text-link cart-continue" href="${esc(shopURL())}">${icon('arrow-left')} Continue shopping</a></div><aside class="cart-page-summary" aria-label="Order summary">${cartSummary()}</aside></div>`
        : `<div class="cart-page-empty">${cartEmpty('h1')}</div>`;
    }
  }
  const cartItem = key => cart.items?.find(item => item.key === key);
  const focusSelector = selector => document.querySelector(selector)?.focus();

  /* Search dialog */
  function setSearchScope(context) {
    searchContext = { ...context };
    document.getElementById('search-title').textContent = `Search ${context.model || context.brand || 'all'} parts`;
    document.getElementById('search-scope').textContent = [context.brand || 'All brands', context.model, context.category || 'All part types'].filter(Boolean).join(' · ');
    document.getElementById('search-all-brands').hidden = !context.brand && !context.model && !context.category;
    searchSuggestions(document.getElementById('search-input').value);
  }
  function searchSuggestions(query) {
    const target = document.getElementById('search-suggestions');
    const context = { ...(searchContext || browseContext()), q: query.trim(), sort: 'featured' };
    const list = matchingProducts(context).slice(0, 4);
    const universal = context.brand ? universalProducts(context).slice(0, 2) : [];
    const suggestion = p => `<a href="${esc(p.url)}"><span class="od-field od-fill"><strong>${esc(p.shortName)}</strong><span class="muted">${esc(fitLabel(p))}</span></span><span class="suggestion-price">${money(p.price)}</span></a>`;
    target.innerHTML = `<p>${list.length ? context.q ? 'Matching parts in this collection' : 'Suggested starting points' : 'No listings match in this collection. Try another part name or search all brands.'}</p>${list.map(suggestion).join('')}${universal.length ? `<div class="search-universal"><p><strong>Universal options · Check fitment</strong></p>${universal.map(suggestion).join('')}</div>` : ''}`;
  }

  /* Validation */
  function fieldError(field, message) {
    const errorId = field.getAttribute('aria-describedby');
    const error = errorId ? document.getElementById(errorId) : null;
    field.setAttribute('aria-invalid', message ? 'true' : 'false');
    if (error) { error.textContent = message; error.hidden = !message; }
  }
  function validQuantity(field) {
    const n = Number(field.value);
    const valid = Number.isInteger(n) && n >= 1 && n <= 99;
    fieldError(field, valid ? '' : 'Choose a whole quantity between 1 and 99.');
    return valid;
  }

  /* Rendering */
  function renderPage() {
    if (onShopPage) renderShop();
    else if (onBikesPage) renderBikes();
    else if (onProductPage) renderProductDynamic();
    else if (onCartPage) renderCart();
    else if (template === 'index') renderHome();
    updateHeader();
    if (!firstRender) {
      requestAnimationFrame(() => {
        let top = preserveScroll ?? 0;
        const anchor = document.querySelector('.shop-type-anchor');
        if (anchor && preserveScroll !== null) {
          const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height')) || 0;
          top = Math.min(top, Math.max(0, anchor.getBoundingClientRect().top + window.scrollY - headerHeight));
        }
        window.scrollTo({ top, behavior: 'instant' });
        if (pendingFocus) document.getElementById(pendingFocus)?.focus({ preventScroll: true });
        else document.getElementById('app')?.focus({ preventScroll: true });
        pendingFocus = null; preserveScroll = null;
      });
    }
    firstRender = false;
  }

  document.addEventListener('focusout', e => {
    const field = e.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement)) return;
    if (field.closest('[data-form="bike"]') && field.required && !field.disabled) fieldError(field, field.value ? '' : 'Choose Honda or Royal Enfield.');
    if (field.name === 'quantity' && field.closest('[data-form="purchase"]')) validQuantity(field);
    requestAnimationFrame(syncPurchaseBar);
  });
  document.addEventListener('input', e => {
    if (e.target.id === 'search-input') searchSuggestions(e.target.value);
  });
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.dataset.form) return;
    e.preventDefault();
    const data = new FormData(form);
    if (form.dataset.form === 'bike') {
      const brand = form.elements.brand; const model = form.elements.model;
      fieldError(brand, brand.value ? '' : 'Choose Honda or Royal Enfield.');
      if (!brand.value) { brand.focus(); return; }
      if (model.value && !bikes[brand.value]?.includes(model.value)) { model.focus(); return; }
      setBike(brand.value, model.value);
      if (bikeReturnCart) {
        bikeReturnCart = false; closeDialogs(); renderPage(); openDialog('cart-dialog'); notify('Your bike has been saved.');
      } else if (onProductPage || onCartPage) {
        closeDialogs(); renderPage(); notify('Your bike has been saved.');
        if (onProductPage) document.getElementById('product-fitment-status')?.scrollIntoView({ block: 'center', behavior: 'instant' });
      } else if (!model.value) navigate(bikeSelectionURL(brand.value));
      else navigate(shopURL({ brand: brand.value, model: model.value, category: '', q: '', sort: 'featured' }));
      return;
    }
    if (form.dataset.form === 'search') {
      const q = String(data.get('q') || '').trim();
      navigate(shopURL({ q }, searchContext || browseContext(), onShopPage ? shopPath : routes.all));
      return;
    }
    if (form.dataset.form === 'collection-search') {
      navigate(shopURL({ q: String(data.get('q') || '').trim() }, getFilters()), { preserveScroll: true, focusId: 'results-title' });
      return;
    }
    if (form.dataset.form === 'purchase') {
      const p = productPage; if (!p) return;
      const v = p.variants.find(item => String(item.id) === String(data.get('id')));
      const field = form.elements.quantity;
      if (!validQuantity(field)) { field.scrollIntoView({ block: 'center', behavior: 'instant' }); field.focus(); return; }
      if (!v?.available) { notify('This option is currently unavailable.'); return; }
      const { selected: fitment, fit } = shopperFitment(p);
      const bikeLabel = productBikeName(fitment);
      const qty = Number(field.value);
      rememberPurchase();
      const existing = cart.items?.find(item => String(item.variant_id) === String(v.id) && item.properties?.Bike === bikeLabel);
      if (existing && existing.quantity + qty > 99) { notify('You can add up to 99 of each part.'); return; }
      const buttons = [document.getElementById('add-to-cart'), document.getElementById('mobile-add-to-cart')];
      buttons.forEach(button => { if (button) button.disabled = true; });
      try {
        const response = await fetch(cartURL(routes.cartAdd), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: qty, properties: { Bike: bikeLabel, _fit_kind: fit.kind, _fit_title: fit.title, _fit_text: fit.text } }] })
        });
        if (!response.ok) { const error = await response.json().catch(() => ({})); notify(error.description || 'This part could not be added to your cart.'); return; }
        await refreshCart();
        openDialog('cart-dialog');
        notify(`${p.shortName} added to your cart.`);
      } catch {
        notify('This part could not be added to your cart. Check your connection and try again.');
      } finally {
        syncPurchaseControls();
      }
    }
  });
  document.addEventListener('change', async e => {
    const el = e.target;
    const form = el.closest('form');
    if (form?.dataset.form === 'bike' && el.name === 'brand') {
      const model = form.elements.model; model.disabled = !el.value;
      model.innerHTML = '<option value="">All models</option>' + (bikes[el.value] || []).map(m => `<option>${esc(m)}</option>`).join('');
      fieldError(el, ''); fieldError(model, '');
    }
    if (form?.dataset.form === 'purchase' && el.name === 'quantity') syncPurchaseControls();
    if (el.dataset.action === 'sort') navigate(shopURL({ sort: el.value }, getFilters()), { preserveScroll: true, focusId: 'sort' });
    if (el.dataset.action === 'variant' && productPage) {
      const v = productPage.variants.find(item => String(item.id) === el.value); if (!v) return;
      productState.variant = String(v.id);
      if (Number.isInteger(v.imageIndex) && productPage.images[v.imageIndex]) selectGallery(productPage, v.imageIndex);
      syncPurchaseControls();
    }
    if (el.dataset.action === 'cart-quantity') {
      const item = cartItem(el.dataset.key); if (!item) return;
      const n = Number(el.value);
      if (!Number.isInteger(n) || n < 1 || n > 99) { el.value = item.quantity; notify('Choose a whole quantity between 1 and 99.'); return; }
      const scope = el.closest('dialog, [data-cart-page]') || document;
      await changeCartLine(item.key, n); renderCart(); scope.querySelector(`[data-cart-key="${CSS.escape(cartItem(el.dataset.key)?.key || el.dataset.key)}"] [data-action="cart-quantity"]`)?.focus();
    }
  });
  document.addEventListener('click', async e => {
    const control = e.target.closest('[data-action]');
    if (control && !(control.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey))) {
      const action = control.dataset.action;
      const handled = () => { e.preventDefault(); };
      if (action === 'close') { closeDialog(control.closest('dialog')); return; }
      if (action === 'cart') { handled(); openDialog('cart-dialog'); return; }
      if (action === 'search') { handled(); openDialog('search-dialog'); return; }
      if (action === 'menu') { openDialog('menu-dialog'); return; }
      if (action === 'help') { openDialog('help-dialog'); return; }
      if (action === 'information') { openDialog('information-dialog'); return; }
      if (action === 'choose-bike') {
        if (document.getElementById('cart-dialog')?.open || onProductPage || onCartPage) openDialog('bike-dialog');
        else navigate(bikeSelectionURL(browseContext().brand || bike.brand));
        return;
      }
      if (action === 'home-showcase') {
        const brand = control.dataset.brand;
        if (brand !== '' && !Object.hasOwn(bikes, brand)) return;
        if (brand === showcaseBrand) return;
        showcaseBrand = brand;
        showcaseLimit = showcasePageSize;
        refreshHomeShowcase(control.id); return;
      }
      if (action === 'showcase-more') {
        handled();
        const firstNewIndex = Math.min(showcaseLimit, showcaseProducts().length);
        showcaseLimit += showcasePageSize;
        refreshHomeShowcase(null, firstNewIndex); return;
      }
      if (action === 'part-category') {
        navigate(shopURL({ category: control.dataset.category }, getFilters()), { preserveScroll: true, focusId: control.id }); return;
      }
      if (action === 'search-all-brands') {
        setSearchScope({ brand: '', model: '', category: '', q: '', sort: 'featured' });
        document.getElementById('search-input').focus(); return;
      }
      if (action === 'fit-pick') {
        const brand = control.dataset.brand, model = control.dataset.model;
        if (!bikes[brand]?.includes(model)) return;
        setBike(brand, model);
        renderProductDynamic();
        document.querySelector('[data-fitment-panel]')?.classList.add('anim-fade');
        document.querySelector('[data-fitment-panel] .pdp-fit-help')?.focus({ preventScroll: true });
        return;
      }
      if (action === 'quick-add') {
        const p = findProduct(control.dataset.product);
        if (!p || control.disabled) return;
        const { selected: fitment, fit } = shopperFitment(p);
        const bikeLabel = productBikeName(fitment);
        const existing = cart.items?.find(item => String(item.variant_id) === String(p.variantId) && item.properties?.Bike === bikeLabel);
        if (existing && existing.quantity >= 99) { notify('You can add up to 99 of each part.'); return; }
        control.disabled = true;
        control.classList.add('is-busy');
        try {
          const response = await fetch(cartURL(routes.cartAdd), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: p.variantId, quantity: 1, properties: { Bike: bikeLabel, _fit_kind: fit.kind, _fit_title: fit.title, _fit_text: fit.text } }] })
          });
          if (!response.ok) { const error = await response.json().catch(() => ({})); notify(error.description || 'This part could not be added to your cart.'); return; }
          await refreshCart();
          control.classList.add('is-added');
          control.innerHTML = `${icon('check')}<span class="card-add-label">Added</span>`;
          control.setAttribute('aria-label', `${p.shortName} added to cart`);
          notify(`${p.shortName} added to your cart.`, true);
          setTimeout(() => {
            if (!control.isConnected) return;
            control.classList.remove('is-added');
            control.innerHTML = `${icon('bag-plus')}<span class="card-add-label">Add</span>`;
            control.setAttribute('aria-label', `Add ${p.shortName} to cart`);
          }, 2000);
        } catch {
          notify('This part could not be added to your cart. Check your connection and try again.');
        } finally {
          control.disabled = false;
          control.classList.remove('is-busy');
        }
        return;
      }
      if (action === 'gallery' && productPage) { selectGallery(productPage, Number(control.dataset.index)); return; }
      if (action === 'gallery-step' && productPage) { selectGallery(productPage, Math.max(0, Math.min(productPage.images.length - 1, productState.image + Number(control.dataset.step)))); return; }
      if (action === 'zoom' && productPage) {
        if (!productPage.images.length) return;
        const index = Number.isInteger(Number(control.dataset.index)) && control.dataset.index !== undefined ? Number(control.dataset.index) : productState.image;
        lightboxState = { index, zoomed: false }; paintLightbox(); openDialog('lightbox-dialog'); return;
      }
      if (action === 'lightbox-previous' || action === 'lightbox-next') { moveLightbox(action === 'lightbox-next' ? 1 : -1); return; }
      if (action === 'lightbox-zoom') { if (lightboxState) { lightboxState.zoomed = !lightboxState.zoomed; paintLightbox(); document.getElementById('lightbox-stage').focus(); } return; }
      if (action === 'product-info') {
        const content = document.getElementById('product-info-content');
        if (!content) return;
        document.querySelector('#product-info-dialog .dialog-body').replaceChildren(content.content.cloneNode(true));
        openDialog('product-info-dialog'); return;
      }
      if (action === 'quantity-plus' || action === 'quantity-minus') {
        const input = control.closest('.quantity-control').querySelector('input');
        input.value = Math.max(1, Math.min(99, (Number.parseInt(input.value, 10) || 1) + (action === 'quantity-plus' ? 1 : -1))); fieldError(input, ''); syncPurchaseControls(); return;
      }
      if (action === 'clear-filters') { navigate(shopURL({ category: '', q: '' }, getFilters()), { preserveScroll: true, focusId: 'results-title' }); return; }
      if (action === 'remove-filter') {
        const key = control.dataset.key; const updates = { [key]: '' }; if (key === 'brand') updates.model = '';
        navigate(shopURL(updates, getFilters()), { preserveScroll: true, focusId: 'results-title' }); return;
      }
      const key = control.dataset.key;
      if (action === 'cart-plus' || action === 'cart-minus') {
        const item = cartItem(key); if (!item) return;
        await changeCartLine(key, Math.max(1, Math.min(99, item.quantity + (action === 'cart-plus' ? 1 : -1))));
        const scope = control.closest('dialog, [data-cart-page]') || document;
        renderCart();
        scope.querySelector(`[data-cart-key="${CSS.escape(cartItem(key)?.key || key)}"] [data-action="${action}"]`)?.focus(); return;
      }
      if (action === 'remove-item') {
        const item = cartItem(key); if (!item) return;
        lastRemoved = { id: item.variant_id, quantity: item.quantity, properties: item.properties || {} };
        const name = findProduct(item.handle)?.shortName || item.product_title;
        const line = control.closest('.cart-line');
        if (line && !reduceMotion()) { line.classList.add('is-removing'); await new Promise(r => setTimeout(r, 220)); }
        await changeCartLine(key, 0);
        renderCart();
        (control.closest('dialog') ? document.getElementById('cart-title') : document.querySelector('[data-cart-page] h1'))?.focus();
        notify(`${name} removed.`, false, true);
        return;
      }
      if (action === 'cart-undo') {
        if (!lastRemoved) return;
        const restore = lastRemoved; lastRemoved = null;
        const response = await fetch(cartURL(routes.cartAdd), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [restore] }) });
        if (!response.ok) { notify('That part could not be restored.'); return; }
        await refreshCart(); cartChanged = true; renderCart();
        document.getElementById('toast').hidden = true;
        return;
      }
    }
    const link = e.target.closest('a[href]');
    if (!link || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target === '_blank') return;
    let url;
    try { url = new URL(link.href, location.href); } catch { return; }
    if (url.origin !== location.origin) return;
    if (link.dataset.bikeModel) {
      const brand = link.dataset.bikeBrand, model = link.dataset.bikeModel;
      if (bikes[brand]?.includes(model)) setBike(brand, model);
    }
    if (url.pathname.includes('/products/')) {
      const context = link.closest('[data-browse-shop]')?.dataset.browseShop;
      if (context) rememberShop(context);
      else if (onShopPage) rememberShop(currentPath());
      else if (!onProductPage) rememberShop(shopURL({}, browseContext(), routes.all));
      return;
    }
    if (url.pathname === location.pathname && ((onShopPage && url.searchParams.get('view') !== 'bikes') || (onBikesPage && url.searchParams.get('view') === 'bikes')) && url.hash === '') {
      e.preventDefault();
      navigate(url.href);
    }
  });
  document.addEventListener('click', e => {
    const link = e.target.closest('a[href]');
    if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
    let url; try { url = new URL(link.href, location.href); } catch { return; }
    if (url.origin !== location.origin || (url.pathname === location.pathname && url.search === location.search)) return;
    startNavProgress();
  });
  document.addEventListener('focusin', syncPurchaseBar);
  document.addEventListener('keydown', e => {
    if (!document.getElementById('lightbox-dialog')?.open || lightboxState?.zoomed || e.altKey || e.ctrlKey || e.metaKey) return;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); moveLightbox(e.key === 'ArrowRight' ? 1 : -1); }
  });
  window.addEventListener('resize', syncPurchaseBar, { passive: true });
  window.visualViewport?.addEventListener('resize', syncPurchaseBar, { passive: true });
  window.addEventListener('scroll', syncPurchaseBar, { passive: true });
  window.addEventListener('popstate', () => { closeDialogs(); if (onShopPage || onBikesPage) { preserveScroll = null; renderPage(); } });
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCart().catch(() => {}); });

  if (onProductPage) body.classList.add('on-product');
  renderPage();
  syncSegments();
  observeReveal();
  window.addEventListener('resize', () => syncSegments(), { passive: true });
  if (onProductPage) { setupPurchaseBar(); setupGallery(); }
})();
